import { ref } from '@vue/composition-api'
import useForm from '@/compositions/useForm'
import { requiredIf } from '@/utils/validations'

export default {
  name: 'NewMessageForm',
  props: {
    loading: Boolean,
  },
  setup(props, context) {
    const { emit } = context
    const files = ref([])

    const {
      validate, $errors, formData, reset,
    } = useForm({
      fields: {
        text: { default: '', validations: { required: requiredIf(() => !files.value.length) } },
        file: { default: undefined },
      },
    })

    const addFile = (val) => {
      if (!Array.isArray(val)) {
        files.value.push(val)
        return
      }
      val.forEach((v) => {
        files.value.push(v)
      })
    }

    const removeFile = (index) => {
      files.value.splice(index, 1)
    }

    const getSizeTitle = (size) => {
      let newSize = size
      if (newSize < 1000) return `${newSize} Б`
      newSize /= 1000
      if (newSize < 1000) return `${newSize} КБ`
      newSize /= 1000
      return `${newSize} МБ`
    }

    const getFilesArray = () => {
      const filesArray = files.value.map(file => ({
        name: file.name,
        document_type: file.type,
        file,
      }))
      return filesArray
    }

    const submit = () => {
      if (!validate()) return
      emit('sendMessage', { text: formData.text.value, documentsAttributes: getFilesArray() })
      reset()
      files.value = []
    }

    return {
      submit,
      $errors,
      formData,
      files,
      addFile,
      removeFile,
      getSizeTitle,
    }
  },
}
